
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/lib/toast"

interface UserProfile {
  id: string;
  name: string | null;
  email: string | null;
  telefone: string | null;
  cpf: string | null;
  empresa_id: number | null;
  nivel: number | null;
  foto_perfil_url: string | null;
  created_at: string;
  empresas?: {
    nome_fantasia: string | null;
    razao_social: string | null;
    ativo?: boolean | null;
  } | null;
}

export const useProfileQueries = () => {
  const loadCompleteUserProfile = async (userId: string): Promise<UserProfile | null> => {
    console.log("=== CARREGAMENTO PROFILE DEFINITIVO ===");
    console.log("User ID:", userId);

    try {
      // Query 1: Carregar dados do usuário
      const { data: userData, error: userError } = await supabase
        .from('users')
        .select(`
          id,
          name,
          email,
          telefone,
          cpf,
          empresa_id,
          nivel,
          foto_perfil_url,
          created_at
        `)
        .eq('id', userId)
        .maybeSingle();

      console.log("✅ DADOS DO USUÁRIO:", userData);
      console.log("Erro usuário:", userError);

      if (userError) {
        console.error("Erro ao carregar usuário:", userError);
        toast.error("Erro ao carregar dados do perfil");
        return null;
      }

      if (!userData) {
        console.error("Usuário não encontrado:", userId);
        toast.error("Perfil não encontrado");
        return null;
      }

      // Query 2: Carregar dados da empresa se empresa_id existir
      let empresaData = null;
      if (userData.empresa_id) {
        console.log("=== CARREGANDO EMPRESA ID:", userData.empresa_id, "===");
        
        const { data: companyData, error: companyError } = await supabase
          .from('empresas')
          .select('nome_fantasia, razao_social, ativo')
          .eq('id', userData.empresa_id)
          .maybeSingle();
        
        console.log("✅ DADOS DA EMPRESA:", companyData);
        console.log("Erro empresa:", companyError);
        
        if (!companyError && companyData) {
          empresaData = companyData;
          console.log("✅ EMPRESA ANEXADA AO PROFILE:", empresaData);
        } else {
          console.warn("❌ FALHA AO CARREGAR EMPRESA:", companyError);
        }
      } else {
        console.log("❌ USUÁRIO SEM EMPRESA_ID");
      }

      // Combinar dados
      const completeProfile: UserProfile = {
        ...userData,
        empresas: empresaData
      };

      console.log("🎯 PROFILE FINAL COMPLETO:", completeProfile);
      return completeProfile;
      
    } catch (error) {
      console.error("Erro geral ao carregar profile:", error);
      toast.error("Erro ao carregar perfil");
      return null;
    }
  };

  // Manter métodos antigos para compatibilidade (não são mais usados)
  const loadUserData = async (userId: string): Promise<UserProfile | null> => {
    console.log("=== QUERY 1: DADOS DO USUÁRIO ===");
    
    const { data: userData, error: userError } = await supabase
      .from('users')
      .select(`
        id,
        name,
        email,
        telefone,
        cpf,
        empresa_id,
        nivel,
        foto_perfil_url,
        created_at
      `)
      .eq('id', userId)
      .maybeSingle();

    console.log("Dados do usuário:", userData);
    console.log("Erro da query usuário:", userError);

    if (userError) {
      console.error("Erro ao carregar dados do usuário:", userError);
      toast.error("Erro ao carregar dados do perfil");
      return null;
    }

    if (!userData) {
      console.error("Nenhum perfil encontrado para o usuário:", userId);
      toast.error("Perfil não encontrado");
      return null;
    }

    return userData;
  };

  const loadCompanyData = async (empresaId: number) => {
    console.log("=== QUERY 2: DADOS DA EMPRESA ===");
    console.log("empresa_id do usuário:", empresaId);

    const { data: empresaData, error: empresaError } = await supabase
      .from('empresas')
      .select('nome_fantasia, razao_social, ativo')
      .eq('id', empresaId)
      .maybeSingle();

    console.log("Dados da empresa:", empresaData);
    console.log("Erro da query empresa:", empresaError);

    if (!empresaError && empresaData) {
      console.log("✅ EMPRESA CARREGADA COM SUCESSO:", empresaData);
      return empresaData;
    } else {
      console.warn("❌ Erro ao carregar empresa:", empresaError);
      return null;
    }
  };

  return {
    loadCompleteUserProfile,
    loadUserData,
    loadCompanyData
  };
};
